import { render, staticRenderFns } from "./PreviewRegistrationForm.vue?vue&type=template&id=237a0f9b&"
import script from "./PreviewRegistrationForm.vue?vue&type=script&lang=js&"
export * from "./PreviewRegistrationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports